// extracted by mini-css-extract-plugin
module.exports = {"PowerStation":"jp_PowerStation__hkYtv"};